import React, { useEffect, useState } from "react";
import QTextBox from "../../../../common/components/QTextBox";
import { ResponseInterface } from "../../../../interfaces/ResponseInterface";
import { config } from "../../../../config";
import {Col, FormGroup, Input, Row} from "reactstrap";
import { Formik } from "formik";
import QButton from "../../../../common/components/QButton";
import { useDispatch } from "react-redux";
import {setLoading, setToast} from "../../../../app/rootReducer";
import SetupApi from "../../../../common/api/functions/Setup";
import { SetupInterface } from "../../../../interfaces/private/SetupInterface";
import { useHistory } from "react-router-dom";
import { QHelpers } from "../../../../common/helpers";
import { RouteDefine } from "../../../../routes/RouteDefine";
import { useTranslation } from "react-i18next";
import QSelect from "../../../../common/components/QSelect";
import { SelectOptionInterface } from "../../../../interfaces/SelectOptionInterface";
import { log } from "console";
import * as yup from "yup";
import {
    AccountInterface,
    JournalInterface,
    LayoutInterface,
    PaymentTermInterface
} from "../../../../interfaces/economic/CommonInterface";
import {AnimatePresence, motion} from "framer-motion";

interface Props {
    model: SetupInterface,
    setOpen: Function,
    setLoadingFunc: Function,
    setSetup: Function,
    setup: SetupInterface,
    allDataSetup: any,
    /** Called after a successful save (e.g. continue ledger setup → Payout). */
    onSaved?: (updatedSetup: SetupInterface) => void,
}
interface Layout{
    layoutNumber: number,
    name: string
}
const BodyPaymentSetupComponent: React.FC<Props> = ({allDataSetup, model, setOpen, setLoadingFunc, setSetup,setup, onSaved }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);

    const {cashbooks,accounts} = allDataSetup;
    useEffect(() => {
        if (loading) {
            load().then(async () => {setLoading(false)})
        }
    }, [loading])

    const load = async () => {
        try {
            await SetupApi.detail().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    setSetup(
                        response?.data?.data || {}
                    )
                }
            })

        } catch (err) {
        }
        if (loading) {
            await setLoading(false);
        }
    }


    return (
        <React.Fragment>
            <Formik
                initialValues={{
                    ...setup,
                    economic_payment_matching_invoice: setup.economic_payment_matching_invoice ?? false,
                    accounting_mode: setup.accounting_mode || "invoice_matching",
                }}
                enableReinitialize={true}
                validationSchema={yup.object().shape({
                    economic_payment_cashbook_number: yup.string().required("Please choose cashbook for payment"),
                    economic_payment_bank_account_number: yup.string().required("Please choose bank account"),
                    economic_payment_sales_account_number: yup.string().when("accounting_mode", {
                        is: "customer_balance_ledger",
                        then: yup.string().required("Please choose sales account"),
                        otherwise: yup.string().nullable(),
                    }),
                    economic_payment_credit_account_number: yup.string().when(
                        ["economic_payment_matching_invoice", "accounting_mode"],
                        {
                            is: (matching: boolean, mode: string) =>
                                !matching && mode !== "customer_balance_ledger",
                            then: yup.string().required("Please choose credit account"),
                            otherwise: yup.string().nullable(),
                        }
                    ),
                    economic_payment_fee_account_number: yup.string().required("Please choose fee account"),
                    economic_payment_difference_currency_account_number: yup.string().required("Please choose difference currency account"),
                })}
                onSubmit={(values: any) => {
                    SetupApi.update(values).then(async (response: ResponseInterface | any) => {
                        if (response.status === config.STATUS_CODE.OK) {
                            const updated = response?.data?.data || {};
                            setSetup(updated)

                            await setOpen(false);
                            await setLoadingFunc(true);
                            await dispatch(setToast({
                                message: "Update success",
                                type: config.TOAST_TYPE.SUCCESS
                            }))
                            if (onSaved) {
                                onSaved(updated);
                            }
                        }
                    })
                }}
            >
                {formik => {
                    const isLedger = (formik.values.accounting_mode || "invoice_matching") === "customer_balance_ledger";
                    return (
                        <React.Fragment>
                            <Row>
                                <Col>
                                    <QSelect
                                        label={'Cashbook'}
                                        value={parseInt(formik.values.economic_payment_cashbook_number)}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_payment_cashbook_number',option.value);
                                        }}
                                        options={cashbooks.map((a:JournalInterface)=>({label:a.name,value:a.journalNumber}))}
                                        error={formik.errors?.economic_payment_cashbook_number}
                                    />
                                    <QSelect
                                        label={'Bank account'}
                                        value={parseInt(formik.values.economic_payment_bank_account_number)}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_payment_bank_account_number',option.value);
                                        }}
                                        options={accounts.map((a:AccountInterface)=>({label:a.accountNumber + ' - ' + a.name,value:a.accountNumber}))}
                                        error={formik.errors?.economic_payment_bank_account_number}
                                    />
                                    <QSelect
                                        label={'Fee account'}
                                        value={parseInt(formik.values.economic_payment_fee_account_number)}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_payment_fee_account_number',option.value);
                                        }}
                                        options={accounts.map((a:AccountInterface)=>({label:a.accountNumber + ' - ' + a.name,value:a.accountNumber}))}
                                        error={formik.errors?.economic_payment_fee_account_number}
                                    />
                                    <QSelect
                                        label={'Difference currency account'}
                                        value={parseInt(formik.values.economic_payment_difference_currency_account_number)}
                                        onChange={(option:SelectOptionInterface) => {
                                            formik.setFieldValue('economic_payment_difference_currency_account_number',option.value);
                                        }}
                                        options={accounts.map((a:AccountInterface)=>({label:a.accountNumber + ' - ' + a.name,value:a.accountNumber}))}
                                        error={formik.errors?.economic_payment_difference_currency_account_number}
                                    />
                                    {isLedger ? (
                                        <React.Fragment>
                                            <QSelect
                                                label={t("economic.salesAccount")}
                                                value={parseInt(formik.values.economic_payment_sales_account_number)}
                                                onChange={(option: SelectOptionInterface) => {
                                                    formik.setFieldValue('economic_payment_sales_account_number', option.value);
                                                }}
                                                options={accounts.map((a: AccountInterface) => ({
                                                    label: a.accountNumber + ' - ' + a.name,
                                                    value: a.accountNumber
                                                }))}
                                                error={formik.errors?.economic_payment_sales_account_number}
                                            />
                                            <p className="text-muted small">{t("economic.accountingModeCustomerLedgerHelp")}</p>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                    <FormGroup switch>
                                        <label>{t("economic.matchingInvoice")}</label>
                                        <Input
                                            type="switch"
                                            value={formik.values.economic_payment_matching_invoice}
                                            checked={formik.values.economic_payment_matching_invoice}
                                            onChange={(e) => {
                                                formik.setFieldValue('economic_payment_matching_invoice', e.target.checked, false);
                                            }}
                                        />
                                    </FormGroup>
                                    {formik.values.economic_payment_matching_invoice ? (
                                        <p className="text-muted small">{t("economic.matchingInvoiceHelp")}</p>
                                    ) : null}
                                    <AnimatePresence>

                                        {!formik.values.economic_payment_matching_invoice && (
                                            <motion.div
                                                initial={{opacity: 0, height: 0}}
                                                animate={{opacity: 1, height: "auto"}}
                                                exit={{opacity: 0, height: 0}}
                                                transition={{duration: 0.3, ease: "easeInOut"}}
                                            >
                                                <QSelect
                                                    label={'Credit account'}
                                                    value={parseInt(formik.values.economic_payment_credit_account_number)}
                                                    onChange={(option: SelectOptionInterface) => {
                                                        formik.setFieldValue('economic_payment_credit_account_number', option.value);
                                                    }}
                                                    options={accounts.map((a: AccountInterface) => ({
                                                        label: a.accountNumber + ' - ' + a.name,
                                                        value: a.accountNumber
                                                    }))}
                                                    error={formik.errors?.economic_payment_credit_account_number}
                                                /></motion.div>)}
                                    </AnimatePresence>
                                        </React.Fragment>
                                    )}
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'d-flex justify-content-end gap-2'}>
                                        <QButton
                                            type={'default'}
                                            onClick={() => {
                                                setOpen(false)
                                            }}
                                            content={t("common.button.cancel")}
                                        />

                                        <QButton
                                            type={'primary'}
                                            onClick={() => {
                                                formik.handleSubmit()
                                            }}
                                            content={t("common.button.submit")}
                                        />

                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                }}
            </Formik>
        </React.Fragment>
    )
}

export default BodyPaymentSetupComponent
